import Vue from 'vue'
import Vuex from 'vuex'
import WordpressService from '@/helpers/WordpressService'

import config from '@/stores/config'
import status from '@/stores/status'
import menu from '@/stores/menu'
import trivia from '@/stores/trivia'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config,
    status,
    menu,
    trivia,
    tagid: 33907,
    posts: [],
    postsLoading: false,
    videos: [],
    videosLoading: false,
    sponsors: [],
    sponsorsLoading: false
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.status.logo = val
    },
    SET_POSTS_LOADING: (state, loading) => {
      state.postsLoading = loading;
    },
    SET_VIDEOS_LOADING: (state, loading) => {
      state.videosLoading = loading;
    },
    SET_SPONSORS_LOADING: (state, loading) => {
      state.sponsorsLoading = loading;
    },
    STORE_POSTS: (state, { posts }) => {
      state.posts = posts
    },
    STORE_POST: (state, { post }) => {
      state.posts.push(post)
    },
    STORE_VIDEOS: (state, { videos }) => {
      state.videos = videos
    },
    STORE_SPONSORS: (state, { posts }) => {
      state.sponsors = posts
    },
    SET_ANSWER: (state, answer) => {
      state.trivia.answers.push(answer)
    },
    SET_BG: (state, bg) => {
      state.config.bg = bg
    }
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    },
    FETCH_POSTS_FALLBACK({ commit }, getObject) {
      if(typeof getObject.type === 'undefined'){
        getObject.type = 'post'
      }
      if (getObject.type === 'video') {
        commit('SET_VIDEOS_LOADING', true)
      } else if (getObject.type === 'sponsor') {
        commit('SET_SPONSORS_LOADING', true)
      } else {
        commit('SET_POSTS_LOADING', true)
      }
      const ltbasefallback = 'https://copesano.acunaviera.com/app/uploads'
      const jsonselector = {
        video: `${ltbasefallback}/videos.json`,
        post: `${ltbasefallback}/posts.json`,
        sponsor: `${ltbasefallback}/sponsors.json`,
      }
      WordpressService
        .getPostsFallback(jsonselector[getObject.type])
        .then((response) => {
          if (getObject.type === 'video') {
            commit('STORE_VIDEOS', {
              videos: response.posts
            })
            commit('SET_VIDEOS_LOADING', false)
          } else if (getObject.type === 'sponsor') {
            commit('STORE_SPONSORS', {
              posts: response.posts
            })
            commit('SET_SPONSORS_LOADING', false)
          } else {
            commit('STORE_POSTS', {
              posts: response.posts
            })
            commit('SET_POSTS_LOADING', false)
          }
        }, err => {
          console.log('FETCH_POSTS_FALLBACK: err:', err, getObject)
          if (getObject.type === 'video') {
            commit('SET_VIDEOS_LOADING', false)
          } else if (getObject.type === 'sponsor') {
            commit('SET_SPONSORS_LOADING', false)
          } else {
            commit('SET_POSTS_LOADING', false)
          }
        })
    },
    FETCH_POSTS_BY_TAG({ commit }, getObject) {

      if(getObject.type === 'video'){
        commit('SET_VIDEOS_LOADING', true)
      } else if (getObject.type === 'sponsor') {
        commit('SET_SPONSORS_LOADING', true)
      } else {
        commit('SET_POSTS_LOADING', true)
      }

      WordpressService
        .getPostsByTagId(getObject.tagid)
        .then((response) => {
          if(getObject.type === 'video'){
            commit('STORE_VIDEOS', {
              videos: response.posts
            })
            commit('SET_VIDEOS_LOADING', false)
          } else if (getObject.type === 'sponsor'){
            commit('STORE_SPONSORS', {
              posts: response.posts
            })
            commit('SET_SPONSORS_LOADING', false)
          } else {
            commit('STORE_POSTS', {
              posts: response.posts
            })
            commit('SET_POSTS_LOADING', false)
          }
        }, err => {
          console.log('FETCH_POSTS_BY_TAG: err:', err, getObject)
          if (getObject.type === 'video') {
            commit('SET_VIDEOS_LOADING', false)
          } else if (getObject.type === 'sponsor') {
            commit('SET_SPONSORS_LOADING', false)
          } else {
            commit('SET_POSTS_LOADING', false)
          }
          console.log('Fallbacking...')
          this.dispatch('FETCH_POSTS_FALLBACK', { type: getObject.type })
        })
    },

    FETCH_POST({ commit }, getObject) {
      if (!getObject.type) getObject.type = 'post'

      const foundPost = this.getters.getPost(getObject.slug, getObject.type)
      if (typeof foundPost !== 'undefined') { // en memoria
        commit('SET_POSTS_LOADING', false)
      } else { // nope, va a la api
        commit('SET_POSTS_LOADING', true)
        WordpressService
          .getPost(getObject.slug, getObject.type)
          .then((response) => {
            if(response.posts.length > 0){
              commit('STORE_POST', {
                post: response.posts[0]
              })
            }
            commit('SET_POSTS_LOADING', false)
          }, err => {
            console.log('FETCH_POST: err:', err, getObject)
            commit('SET_POSTS_LOADING', false)
            console.log('Fallbacking...')
            this.dispatch('FETCH_POSTS_FALLBACK', { type: 'post' })
            setTimeout(() => {
              this.dispatch('FETCH_POST', getObject)
            }, 3000)

          })
      }
    },
    setAnswer: (context, answer) => {
      context.commit("SET_ANSWER", answer)
    },
    setBg: (context, bg) => {
      context.commit("SET_BG", bg)
    },
  },
  getters: {
    getPost: (state) => (slug, type = 'post') => {
      const foundit = state.posts.find(post => (post.type == type && post.slug === slug))
      if(typeof foundit === 'undefined'){
        return undefined
      } else {
        return foundit
      }
    },
    getQuestion: (state) => (key) => {
      return state.trivia.questions[key]
    },
    getAnswers: (state) => {
      return state.trivia.answers
    },
    actualQuestion: (state, getters) => {
      const answers = getters.getAnswers
      const answersLength = answers.length || 0
      if (answersLength >= state.trivia.questions.length) {
        return false;
      } else {
        return getters.getQuestion(answersLength)
      }
    },
    answerText: (state) => (key) => {
      return state.trivia.answerTexts[key];
    },
    getScore: (state, getters) => {
      const buenas = getters.getAnswers.filter(i => i.result === true).length
      const preguntas = state.trivia.questions.length
      const finales = state.trivia.answerTexts.length

      return {
        percentage: Math.floor((buenas / preguntas) * 100),
        scoreTextIndex: Math.floor((buenas / preguntas) * finales - 1) > 0 ? Math.floor((buenas / preguntas) * finales - 1) : 0
      }
    },
    getScoreTexts: (state, getters) => {
      const score = getters.getScore

      return getters.answerText(score.scoreTextIndex)
    }
  }
})
